<template>
  <div class="header-menu_mob" v-if="menu">
    <div class="header-menu__top-row" v-if="!menuOpened">
      <div class="header-menu__logo">
        <svg
          width="140"
          height="49"
          viewBox="0 0 140 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56.8574" cy="4.07129" r="2" fill="#F0AB00" />
          <circle cx="56.0003" cy="9.49979" r="1.14286" fill="#9DB0AC" />
          <circle cx="52.5716" cy="9.49979" r="1.14286" fill="#9DB0AC" />
          <circle cx="49.1429" cy="11.2141" r="1.14286" fill="#9DB0AC" />
          <circle cx="47.429" cy="14.0711" r="1.14286" fill="#9DB0AC" />
          <circle cx="47.429" cy="17.4998" r="1.14286" fill="#9DB0AC" />
          <circle cx="49.1429" cy="20.3572" r="1.14286" fill="#9DB0AC" />
          <circle cx="52.0003" cy="21.4998" r="1.14286" fill="#9DB0AC" />
          <circle cx="54.8567" cy="23.2141" r="1.14286" fill="#9DB0AC" />
          <circle cx="56.5716" cy="26.0711" r="1.14286" fill="#9DB0AC" />
          <circle cx="56.5716" cy="28.9285" r="1.14286" fill="#9DB0AC" />
          <circle cx="54.8567" cy="31.7854" r="1.14286" fill="#9DB0AC" />
          <circle cx="52.0003" cy="33.4998" r="1.14286" fill="#9DB0AC" />
          <circle cx="48.0003" cy="34.0711" r="1.14286" fill="#9DB0AC" />
          <circle cx="50" cy="4.64258" r="2" fill="#F0AB00" />
          <circle cx="44.8574" cy="8.07129" r="2" fill="#F0AB00" />
          <circle cx="42.5713" cy="12.6426" r="2" fill="#F0AB00" />
          <circle cx="42" cy="18.3569" r="2" fill="#F0AB00" />
          <circle cx="44.8574" cy="23.5" r="2" fill="#F0AB00" />
          <circle cx="49.4287" cy="26.9282" r="2" fill="#F0AB00" />
          <circle cx="54.5713" cy="16.0713" r="2" fill="#830051" />
          <circle cx="59.1426" cy="19.5" r="2" fill="#830051" />
          <circle cx="62" cy="24.0713" r="2" fill="#830051" />
          <circle cx="61.4287" cy="30.3569" r="2" fill="#830051" />
          <circle cx="59.1426" cy="34.9282" r="2" fill="#830051" />
          <circle cx="54" cy="38.3569" r="2" fill="#830051" />
          <circle cx="47.1426" cy="38.9282" r="2" fill="#830051" />
          <path
            d="M5.56934 33.5V31.8457L6.70801 31.6846L11.8857 17.8594H14.5176L19.6309 31.6846L20.7695 31.8457V33.5H15.7959V31.8457L16.9131 31.6416L16.0859 29.1816H10.2637L9.41504 31.6416L10.543 31.8457V33.5H5.56934ZM10.9727 27.1084H15.3877L13.3574 21.3184L13.2178 20.8994H13.1533L13.0029 21.3398L10.9727 27.1084ZM22.2197 33.5V31.6309L30.0615 19.9541H24.7441L24.5186 21.9629H22.4131L22.4883 17.8594H33.3164V19.6748L25.4424 31.416H31.3936L31.6191 29.3213H33.7139L33.6064 33.5H22.2197Z"
            fill="#F0AB00"
          />
          <path
            d="M69.7734 33.5V31.8457L71.4707 31.5234V19.8467L69.7734 19.5244V17.8594H71.4707H75.3486L79.9355 29.1709H80L84.4473 17.8594H90.0869V19.5244L88.3789 19.8467V31.5234L90.0869 31.8457V33.5H83.9746V31.8457L85.7686 31.5234V27.8818L85.79 21.0391L85.7363 21.0283L80.8916 33.1455H78.9258L73.9414 21.0928L73.8877 21.1035L74.0273 27.6992V31.5234L75.8857 31.8457V33.5H69.7734ZM98.3799 33.7256C97.3415 33.7256 96.4033 33.5322 95.5654 33.1455C94.7275 32.7516 94.0078 32.2002 93.4062 31.4912C92.8118 30.7822 92.3535 29.9443 92.0312 28.9775C91.709 28.0107 91.5479 26.9508 91.5479 25.7979V25.5615C91.5479 24.4157 91.709 23.3594 92.0312 22.3926C92.3535 21.4258 92.8118 20.5879 93.4062 19.8789C94.0078 19.1628 94.7275 18.6113 95.5654 18.2246C96.4033 17.8307 97.3379 17.6338 98.3691 17.6338C99.4362 17.6338 100.392 17.8307 101.237 18.2246C102.082 18.6113 102.802 19.1628 103.396 19.8789C103.991 20.5879 104.446 21.4258 104.761 22.3926C105.076 23.3594 105.233 24.4157 105.233 25.5615V25.7979C105.233 26.9508 105.076 28.0107 104.761 28.9775C104.446 29.9443 103.991 30.7822 103.396 31.4912C102.802 32.2002 102.082 32.7516 101.237 33.1455C100.392 33.5322 99.4398 33.7256 98.3799 33.7256ZM98.3799 31.5771C99.3252 31.5771 100.102 31.3372 100.711 30.8574C101.327 30.3704 101.782 29.6937 102.075 28.8271C102.376 27.9606 102.526 26.9508 102.526 25.7979V25.54C102.526 24.4014 102.376 23.4023 102.075 22.543C101.774 21.6836 101.316 21.0104 100.7 20.5234C100.091 20.0365 99.3145 19.793 98.3691 19.793C97.4668 19.793 96.7113 20.0365 96.1025 20.5234C95.4938 21.0104 95.0355 21.6836 94.7275 22.543C94.4196 23.4023 94.2656 24.4014 94.2656 25.54V25.7979C94.2656 26.9437 94.4196 27.9535 94.7275 28.8271C95.0355 29.6937 95.4938 30.3704 96.1025 30.8574C96.7184 31.3372 97.4775 31.5771 98.3799 31.5771ZM112.71 33.7256C111.643 33.7256 110.651 33.5931 109.734 33.3281C108.818 33.0632 107.926 32.6227 107.06 32.0068V28.4082H109.154L109.498 30.7393C109.878 31.0114 110.343 31.2298 110.895 31.3945C111.453 31.5592 112.058 31.6416 112.71 31.6416C113.347 31.6416 113.881 31.5521 114.311 31.373C114.747 31.1868 115.08 30.929 115.31 30.5996C115.539 30.2702 115.653 29.8799 115.653 29.4287C115.653 29.0133 115.553 28.6445 115.353 28.3223C115.152 28 114.819 27.7135 114.354 27.4629C113.888 27.2051 113.258 26.9688 112.463 26.7539C111.296 26.4388 110.318 26.0664 109.53 25.6367C108.75 25.207 108.159 24.6914 107.758 24.0898C107.364 23.4883 107.167 22.7793 107.167 21.9629C107.167 21.125 107.393 20.3838 107.844 19.7393C108.302 19.0947 108.936 18.5863 109.745 18.2139C110.554 17.8415 111.489 17.6517 112.549 17.6445C113.709 17.6302 114.733 17.7806 115.621 18.0957C116.516 18.4108 117.272 18.8226 117.888 19.3311V22.6934H115.836L115.449 20.502C115.156 20.2943 114.772 20.1188 114.3 19.9756C113.834 19.8252 113.283 19.75 112.646 19.75C112.101 19.75 111.621 19.8395 111.206 20.0186C110.791 20.1976 110.465 20.4518 110.229 20.7812C109.992 21.1035 109.874 21.4902 109.874 21.9414C109.874 22.3353 109.978 22.679 110.186 22.9727C110.393 23.2663 110.741 23.5348 111.228 23.7783C111.715 24.0146 112.373 24.2546 113.204 24.498C114.901 24.9492 116.187 25.5723 117.061 26.3672C117.934 27.1621 118.371 28.1755 118.371 29.4072C118.371 30.2738 118.135 31.0329 117.662 31.6846C117.197 32.3291 116.538 32.8304 115.686 33.1885C114.84 33.5465 113.849 33.7256 112.71 33.7256ZM123.57 33.5V31.8457L125.278 31.5234V19.9326H122.131L121.895 21.9307H119.864V17.8594H133.41V21.9307H131.369L131.133 19.9326H127.985V31.5234L129.693 31.8457V33.5H123.57Z"
            fill="#830051"
          />
        </svg>
      </div>
      <div class="header-menu__close" @click="$emit('closeMenu')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.25 5.25L18.75 18.75"
            stroke="#3C4242"
            stroke-width="1.5"
            stroke-linecap="square"
          />
          <path
            d="M18.75 5.25L5.25 18.75"
            stroke="#3C4242"
            stroke-width="1.5"
            stroke-linecap="square"
          />
        </svg>
      </div>
    </div>
    <div class="header-menu__menu">
      <HeaderMenuBlock
        :items="medInfo"
        @menuOpen="menuOpen"
        @closeMenu="$emit('closeMenu')"
        :level="1"
      />
      <HeaderMenuBlock
        class="without-title"
        :items="topMenu"
        @menuOpen="menuOpen"
        @closeMenu="$emit('closeMenu')"
        :level="1"
      />
      <HeaderMenuBlock
        class="without-title"
        :items="menu"
        @menuOpen="menuOpen"
        @closeMenu="$emit('closeMenu')"
        :level="1"
      />
      <div class="header-menu__tools">
        <div v-if="!isAuth">
          <div
            class="button button_empty-pink mb-4 mt-8"
            @click="toRegister"
            v-if="$route.name !== 'Forsiga'"
          >
            Зарегистрироваться
          </div>
          <div
            @click="toLogin"
            class="button button_pink"
            v-if="$route.name !== 'Forsiga'"
          >
            Войти
          </div>
          <div class="header-auth__sso mt-4 mb-4">
            <a
              href="https://login.microsoftonline.com/af8e89a3-d9ac-422f-ad06-cc4eb4214314/oauth2/v2.0/authorize?client_id=4801abdb-5bbb-415a-b78f-aa34886ffd31&scope=api://4801abdb.astrazeneca.net/user_impersonation&response_type=token"
              class="button_gray button"
            >
              Вход сотрудникам AZ
            </a>
          </div>
        </div>
        <div v-else>
          <HeaderMyAz class="mt-8 pb-4" />
          <!-- <div class="header__user header-user" data-id="headerCabinet">
            <div class="header-user__image-container">
              <img
                class="header-user__image"
                :src="
                  user.photo
                    ? $root.host + user.photo
                    : user.default_photo ||
                      `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/content/cabinet/default-avatar.svg`
                "
              />
            </div>
            <div class="header-user__text">
              <div class="header-user__name">
                {{ user.first_name }}
                {{ user.middle_name }}
                {{ user.last_name }}
              </div>
              <div class="header-user__speciality">
                {{ user.speciality }}
              </div>
            </div>
          </div>
          <div
            class="button button_empty-pink mb-4 mt-6"
            @click="toCabinet({ name: 'Cabinet' })"
          >
          <div class="button button_pink" @click="logoutEvent">Выйти</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HeaderMyAz from "@/components/main/HeaderMyAz.vue";
import HeaderMenuBlock from "./HeaderMenuBlock";
import { bus } from "@/main";
export default {
  name: "HeaderMenuMob",
  components: { HeaderMenuBlock, HeaderMyAz },
  props: {
    menu: Array,
    topMenu: Array,
  },
  data: () => ({
    menuOpened: false,
  }),
  computed: {
    ...mapGetters(["user"]),
    isAuth() {
      return this.user && Object.keys(this.user).length;
    },
    medInfo() {
      return [
        {
          title: "Сервис МедИнфо",
          link: { name: "MedInfo" },
        },
      ];
    },
  },
  methods: {
    ...mapActions(["logout"]),
    menuOpen(state) {
      this.menuOpened = state;
    },
    logoutEvent() {
      this.logout();
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "log out", {
          "log out": {
            ...this.$root.ymFields,
          },
        });
      }
    },
    toCabinet(to) {
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "profile logo click", {
          "profile logo click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(to).catch(() => {});
    },
    async toRegister() {
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "registration popup interaction", {
          "registration popup interaction": {
            action: "Зарегистрироваться",
            ...this.$root.ymFields,
          },
        });
      }
      window.open(this.$root.ssoLinks.registration, "_self");
    },
    async toLogin() {
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "registration popup interaction", {
          "registration popup interaction": {
            action: "Войти",
            ...this.$root.ymFields,
          },
        });
      }
      window.open(this.$root.ssoLinks.login, "_self");
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.header {
  &-user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 24px;

    &__image-container {
      margin-right: 8px;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #ebefee;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
      object-position: center;
    }

    &__name {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #830051;
    }

    &__speciality {
      margin-top: 4px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 23px;
      color: #3c4242;
    }
  }
}
.header-menu {
  &_mob {
    padding-top: 32px;
    position: fixed;
    top: 0;
    right: -100%;
    width: 70vw;
    height: 100vh;
    transition: 0.3s;
    background-color: #fff;
    z-index: 9999999;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 24px;

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  &_opened:not([class*="modal-v"]) {
    right: 0;
  }

  &__menu {
    padding: 0 24px;
    position: relative;
    height: 100%;
  }

  &__tools {
    margin: 48px 0 0;
    padding: 0;
    border-top: 1px solid #b2b4b4;
    position: relative;

    @media screen and (max-width: 767px) {
      margin: 24px 0 0;
    }
  }

  &__top-row {
    padding: 0 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__logo {
    margin-right: auto;
  }
}
</style>
<style lang="scss">
.without-title > .header-menu__title {
  font-size: 0;
  line-height: 0;
  border-bottom: 1px solid #d2d2d2;
}
</style>